<template>
  <div class="page">
    <div class="top">
      <div class="top__large">科研创新</div>
      <div class="top__small">Innovation</div>
    </div>
    <div class="content">
      <div class="title" id="advanced_projects">研究项目与成果</div>
      <div class="sub-title">Innovation Projects & Achievements</div>
      <div class="flexBox">
        <List>
          <ListItem
            v-for="(item, index) in projectList"
            :key="index"
            class="listItem1"
            @click="toDetail(item)"
          >
            <ListItemMeta
              :avatar="index % 2 == 0 ? bicon : dbicon"
              :title="item.title"
              :description="item.achievements"
            />
            <template #extra>
              <span>2023-10-13</span>
            </template>
          </ListItem>
        </List>
        <!-- <Page :total="1" /> -->
      </div>

      <div class="title" id="participants" style="margin-top:1.6rem;">优秀科技工作者</div>
      <div class="sub-title">Participants</div>
      <div class="selfIntro">
        <!-- <ul>
          <li
            v-for="item in manlist"
            :key="item.id"
            class="self"
            @click="toParticipants(item.id)"
          >
            <img
              src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/unkuser.jpg"
            />
            <div class="nameNtitle">
              <p>{{ item.name }}</p>
              <p>{{ item.title }}</p>
            </div>
            <div class="intros">
              <p>{{ item.intro }}</p>
            </div>
          </li>
        </ul> -->
        <List>
          <ListItem
            v-for="(item, index) in manlist"
            :key="item.id"
            class="listItem2"
          >
            <ListItemMeta
              :avatar="index % 2 == 0 ? stubicon : studbicon"
              :title="item.name"
              :description="item.title"
            />
            <template #extra>
              <span>2023-10-13</span>
            </template>
            <!-- <template #avatar>
              <Icon type="md-star" />
            </template> -->
            <!-- <template #action>
              <li>
                <a href="#" @click="toParticipants(item.id)">详情</a>
              </li>
            </template> -->
          </ListItem>
        </List>
        <!-- <Page :total="1" /> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "innovation",
  components: {},
  mixins: [],
  props: {},
  data() {
    return {
      projectList: [
        {
          id: 1,
          title: "区域级SHM融合云平台关键技术研发",
          target:
            "针对区域级SHM系统需求，研发“物美价廉”的监测大数据平台（监测平台、运维平台、研究平台）",
          achievements: "专利0篇  论文0篇",
          participants: "郑淳、苏仁智、龙振佳、骆泓杰、何增胜"
        },
        // {
        //   id: 2,
        //   title: "基于计算机视觉技术的车辆荷载识别系统研发",
        //   target: "完善全桥系统识别流程，厘清技术重点，提升识别精度",
        //   achievements: "专利0篇  论文0篇",
        //   participants: "郑淳、龙振佳、苏仁智、何增胜"
        // },
        // {
        //   id: 3,
        //   title: "BIM与SHM的融合技术研发",
        //   target: "基于BIM的网页可视化对SHM的深度适配（优化）",
        //   achievements: "专利0篇  论文0篇",
        //   participants: "郑淳、龙振佳、骆泓杰、何增胜"
        // },
        // {
        //   id: 4,
        //   title: "基于PeraSIM的SHM在线评估系统研发",
        //   target:
        //     "通过嵌入PeraSIM求解模块，实现SHM云分析评估的在线计算。提升粤桥云核心竞争力",
        //   achievements: "专利0篇  论文0篇",
        //   participants: "李保木、郑淳、苏仁智、龙振佳、赵昱辰"
        // }
      ],
      manlist: [
        {
          id: 1,
          name: "何增胜",
          title: "博士（研究生）",
          intro:
            "这是一段介绍这是一段介绍这是一段介绍这是一段介绍这是一段介绍这是一段介绍"
        },
        {
          id: 2,
          name: "滕昊锦",
          title: "硕士（研究生）",
          intro:
            "这是一段介绍这是一段介绍这是一段介绍这是一段介绍这是一段介绍这是一段介绍"
        },
        // {
        //   id: 3,
        //   name: "优秀科技工作者三",
        //   title: "硕士",
        //   intro:
        //     "这是一段介绍这是一段介绍这是一段介绍这是一段介绍这是一段介绍这是一段介绍"
        // },
        // {
        //   id: 4,
        //   name: "优秀科技工作者四",
        //   title: "硕士",
        //   intro:
        //     "这是一段介绍这是一段介绍这是一段介绍这是一段介绍这是一段介绍这是一段介绍"
        // },
        // {
        //   id: 5,
        //   name: "优秀科技工作者五",
        //   title: "硕士",
        //   intro:
        //     "这是一段介绍这是一段介绍这是一段介绍这是一段介绍这是一段介绍这是一段介绍"
        // }
      ],
      bicon:
        "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/kyxm_b.png",
      dbicon:
        "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/kyxm_db.png",
      stubicon:
        "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/stu_b.png",
      studbicon:
        "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/stu_db.png"
    };
  },
  computed: {},
  watch: {},
  created(){
    this.$emit("changeProduce", "innovation");
  },
  mounted() {
    let items1 = document.getElementsByClassName('listItem1')
    items1.forEach((item, index) => {
      item.addEventListener('click', ()=>{
        this.toDetail(this.projectList[index].id)
      })
    })
    let items2 = document.getElementsByClassName('listItem2')
    items2.forEach((item, index) => {
      item.addEventListener('click', ()=>{
        this.toParticipants(this.manlist[index].id)
      })
    })
  },
  methods: {
    toParticipants(id) {
      this.$emit("changeProduce", 'participants', null, id);
      // this.$router.push({ name: "participants", params: { name: "" } });
    },
    toDetail(id) {
      this.$emit("changeProduce", 'innovation_detail', null, id);
    }
  }
};
</script>
<style lang="less" scoped>
.page {
  .top {
    width: 100%;
    height: 3.5rem;//280px
    background: url("https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/advance_banner.jpg")
      center center no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    font-weight: bold;
    color: #fff;
    padding-left: 2.625rem;//210px
    &__large {
      font-size: 0.5rem;
      line-height: 1.5em;
    }
    &__small {
      font-size: 0.375rem;//16px
      line-height: 1.1em;
    }
  }
  .content {
    width: 80%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 0.8rem;
    .title {
      margin: 0.6rem 0 0;
      position: relative;
      font-size: 0.35rem;
      line-height: 1.5em;
      font-weight: bold;
      color: #000;
    }
    .title::after {
      content: "";
      position: absolute;
      bottom: -0.1rem;
      left: 50%;
      transform: translateX(-50%);
      width: 2em;
      height: 0.1rem;
      background-color: #2d8cf0;
    }
    .sub-title {
      margin: 0.125rem 0 0.4rem;
      font-size: 0.22rem;
      line-height: 1.5em;
      color: #6d7278;
    }
    .listItem1, .listItem2{
      width: 12.5rem;
      margin: 0 auto;
      cursor: pointer;
    }
    .flexBox {
      display: block;
      width: 100%;
      // .listItem:nth-child(odd){
      //   background-color: #6699CC;
      // }
      // .listItem:nth-child(even){
      //   background-color: #5072A7;
      // }
      // .listItem:hover{
      //   background-color: #FFF;
      // }
      // ul,
      // li {
      //   margin: 0;
      //   padding: 0;
      //   list-style: none;
      // }

      // ul {
      //   display: flex;
      //   justify-content: center;
      //   flex-direction: row;
      //   flex-wrap: wrap;
      //   width: 100%;
      // }
      // li {
      //   display: block;
      //   width: 40%;
      // }
      // .c2 {
      //   li {
      //     // width: 48%;
      //     margin: 10px;
      //     span {
      //       display: block;
      //       text-indent: 2em;
      //       margin: 5px 0;
      //     }
      //     .ptitle {
      //       font-size: 18px;
      //       line-height: 1.5em;
      //       font-weight: bold;
      //       text-align: center;
      //     }
      //     .pcontent {
      //       margin: 0 0 10px;
      //       font-size: 16px;
      //       line-height: 1.2em;
      //     }
      //   }
      // }
    }

    .selfIntro {
      display: block;
      width: 100%;
      // .listItem:nth-child(odd){
      //   background-color: #5072A7;
      // }
      // .listItem:nth-child(even){
      //   background-color: #6699CC;
      // }
      // ul,
      // li {
      //   margin: 0;
      //   padding: 0;
      //   list-style: none;
      // }
      // ul {
      //   display: flex;
      //   flex-direction: row;
      //   flex-wrap: wrap;
      //   // justify-content: center;
      //   li {
      //     width: 20%;
      //     margin: 10px 0;
      //     padding: 16px 0 0;
      //     img {
      //       width: 60%;
      //       display: block;
      //       margin: 0 auto;
      //     }
      //     .nameNtitle {
      //       display: block;
      //       text-align: center;
      //       background-color: #2d8cf0;
      //       width: 50%;
      //       margin: 10px auto;
      //       line-height: 2em;
      //       color: #fff;
      //       p {
      //         font-size: 14px;
      //       }
      //       p:first-of-type {
      //         font-size: 20px;
      //         font-weight: bolder;
      //       }
      //     }
      //     .intros {
      //       margin: 0 auto;
      //       width: 70%;
      //       padding: 16px;
      //       line-height: 1.2em;
      //       font-size: 14px;
      //     }
      //   }
      //   li:hover {
      //     box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
      //     transition: all 0.5s ease-in-out;
      //     cursor: pointer;
      //     // background-color: #ccc;
      //     // color: #fff;
      //   }
      // }
    }
  }

  .lists {
    display: flex;
    flex-direction: row;
    width: 16rem;
    margin: 0 auto;
    margin-bottom: 0.375rem;
    flex-wrap: wrap;
    justify-content: flex-start;
    li {
      list-style: none;
      width: 3.75rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0.125rem;
      font-size: 0.25rem;

      img {
        width: 100%;
        height: 2.5rem;
        display: block;
      }
      span {
        margin: 0.125rem 0 0;
        width: 100%;
        // white-space: no-wrap;
        // overflow: hidden;
        // text-overflow: ellipsis;
        line-height: 1.5em;
        text-align: center;
      }
    }
  }
}
/deep/ .ivu-list-item-meta-title {
  font-size: 0.3rem;
  font-weight: bold;
  line-height: 1em;
  // color: #BA0021;
  // color: #FFF;
}
/deep/ .ivu-list-item-extra{
  font-size: 0.25rem;
}
/deep/ .ivu-list-item-action {
  a {
    font-size: 0.25rem;
    // color: #15f4ee;
  }
}
/deep/ .ivu-list-item-meta-description {
  font-size: 0.25rem;
  line-height: 1em;
  // color: #000;
}
/deep/ .ivu-card-head {
  font-size: 0.3rem;
  font-weight: bold;
}
/deep/ .ivu-card-body {
  height: 2.5rem;
}
/deep/ .ivu-avatar{
  width: 0.6rem;
  height: 0.6rem;
  font-size: 0.6rem;
  line-height: 1em;
}
</style>
